<template>
  <div class="pto-availability-item">
    <el-row :gutter="10">
      <el-col :span="24">
        <table class="el-table">
          <tbody>
            <tr v-for="(ptoAvailability, index) in ptoAvailabilities" :key="index">
              <th>{{ ptoAvailability.category.name }}:</th>
              <td>{{ ptoAvailability.total }} hours</td>
            </tr>
            <tr>
              <th></th>
              <td>
                <el-button @click="handleOnEdit" size="mini" type="primary">Edit</el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'PtoAvailabilityItem',
    props: {
      userId: {
        type: Number,
        required: true,
      },
      year: {
        type: [Number, String],
        required: true,
      },
      ptoAvailabilities: {
        type: Array,
        required: true,
      },
    },
    computed: {
      ...mapGetters('entities/ptoAvailabilities', ['updating']),
      ...mapGetters('entities/ptos', ['fetching']),
    },
    methods: {
      ...mapActions('entities/ptoAvailabilities', ['openFormModal', 'deletePtoAvailability']),

      handleOnEdit() {
        this.openFormModal({ user_id: this.userId, year: this.year });
      },

      handleDestroy(id) {
        this.$confirm('Do you really want to delete this entry?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.deletePtoAvailability(id)
            .then((response) => {
              if (response.status) {
                showSuccessMessage('PTOs has been deleted successfully');
              } else {
                showErrorMessage(response.error);
              }
            });
        });
      },

    },
  };
</script>

<style lang="scss" scoped>
.el-table::before{
  background-color: transparent;
}
.el-table tr:last-child th{
  width: 150px;
}
.el-table tr:last-child td{
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ptoAvailability/PtoAvailabilityItem.vue